import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import debounce from 'lodash.debounce';

import GlobalStyles from './global-style';
import { fetchData } from './state/slices/data';
import {
  onResize,
  onDarkMode,
  onOrientationChange,
} from './state/slices/browserUtils';

import Header from './views/header';
import Footer from './views/footer';
import Content from './views/content';

import store from './state/store';

const colorSchemeQuery = window.matchMedia('(prefers-color-scheme: dark)');
const portraitView = window.matchMedia('(orientation: portrait)');
const landscapeView = window.matchMedia('(orientation: landscape)');

const container = document.getElementById('foot');
const root = createRoot(container);

const element = (
  <Provider store={store}>
    <GlobalStyles />
    <div className="content-wrap">
      <Header />
      <Content />
      <Footer />
    </div>
  </Provider>
);

root.render(element);

/* Start up functions */
// BrowserUtils
window.addEventListener(
  'resize',
  debounce(() => {
    store.dispatch(
      onResize({ width: window.innerWidth, height: window.innerHeight }),
    );
  }, 200),
);

// listen for dark mode switch
if (colorSchemeQuery) {
  colorSchemeQuery.addEventListener('change', (e) => {
    store.dispatch(onDarkMode({ bool: e.matches }));
  });
}

// orienttation changes
if (portraitView) {
  portraitView.addEventListener('change', (e) => {
    if (e.matches) {
      store.dispatch(onOrientationChange({ orientation: 'portrait' }));
    }
  });
}

if (landscapeView) {
  landscapeView.addEventListener('change', (e) => {
    if (e.matches) {
      store.dispatch(onOrientationChange('landscape'));
    }
  });
}

// send out initial values

store.dispatch(
  onResize({ width: window.innerWidth, height: window.innerHeight }),
);

if (portraitView && portraitView.matches) {
  store.dispatch(onOrientationChange('portrait'));
}

if (landscapeView && landscapeView.matches) {
  store.dispatch(onOrientationChange('landscape'));
}

// Store
store.dispatch(fetchData());

/*

Alt set up using routes


const element = (
  <Provider store={store}>

    <div>
      <GlobalStyles />
      <ConnectedRouter history={history}>
        <Route exact path="/" component={Content} />
        <Route exact path="/footer" component={Footer} />
        <Route exact path="/head" component={Header} />
      </ConnectedRouter>
    </div>
  </Provider>
);


*/
